import { Tooltip } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { TUserOnline } from '@onesource/schemas';

import { StatusBadge } from './styled';

type TProps = {
  member: TUserOnline;
};

export const UserListItem: React.FC<TProps> = ({ member }) => (
  <ListItem
    disableGutters
    sx={{
      py: 0.5,
      borderRadius: 2,
      px: 0.5,
    }}
  >
    <ListItemAvatar sx={{ minWidth: 45 }}>
      <StatusBadge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        variant="dot"
        isActive={member.isActive}
      >
        <Avatar
          src={member.avatarUrl || undefined}
          alt={member.name}
          sx={{
            width: 35,
            height: 35,
            border: '1px solid #fff',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          }}
        />
      </StatusBadge>
    </ListItemAvatar>
    <ListItemText
      primary={
        <>
          <Typography
            sx={{
              fontFamily: "'Figtree', sans-serif",
              fontWeight: 400,
              fontSize: { xs: 14, md: 14 },
              color: theme => theme.palette.common.black,
              lineHeight: 1.6,
            }}
          >
            {member.name}
          </Typography>
          {member.username && (
            <Tooltip title="You can use the username to tag/mention users in the community or comments">
              <Typography
                sx={{
                  fontFamily: "'Figtree', sans-serif",
                  fontWeight: 300,
                  fontSize: { xs: 13, md: 14 },
                  color: theme => theme.palette.grey[800],
                }}
              >
                @{member.username}
              </Typography>
            </Tooltip>
          )}
        </>
      }
      secondary={
        <Typography
          sx={{
            fontFamily: "'Figtree', sans-serif",
            fontSize: { xs: 9, md: 9 },
            color: '#888',
            fontWeight: 500,
            mt: 0.2,
          }}
        >
          {member.isActive ? 'Online now' : 'Recently online'}
        </Typography>
      }
    />
  </ListItem>
);
